var titles = (function ($) {

  var selectors = {
    document: document,
    slider: '#homeSlider',
    modal: '#trailerModal',
    iframe: '#trailerModal iframe',
    embedWrapper: '#trailerEmbed'
  };
  var nodes;

  function infiniteScroll() {
    var ias = $.ias({
      container: '.title-list',
      item: '.title-item',
      pagination: '.pagination',
      next: '[rel="next"]',
      delay: 1600
    });

    ias.extension(new IASSpinnerExtension({
      src: GLOBALS.ajaxLoader,
      html: '<div class="col-12 py-3 text-center"><div class="ias-spinner" style="text-align: center; opacity: 0.8;"><img src="{src}" width="20" height="20"/></div></div>'
    }));
    ias.extension(new IASPagingExtension());
    ias.extension(new IASHistoryExtension({
      prev: '[rel="prev"]'
    }));
  }

  function playVideoEmbed() {
    var embedUrl = nodes.iframe.attr('src');
    nodes.modal.on('shown.bs.modal', function () {
      var embedUrlPlay = embedUrl + '?autoplay=1';
      nodes.iframe.attr('src', embedUrlPlay);
    });

    nodes.modal.on('hidden.bs.modal', function () {
        nodes.iframe.removeAttr('src');
        nodes.iframe.attr('src', embedUrl);
    });
  }

  function loadVideoEmbed() {
    var playBtn = '.video-trailer';

    nodes.document.on('click', playBtn,function(event) {
      event.preventDefault();
      var that = $(this);
      var thePostId = that.attr('data-id');
      nodes.modal.modal('show');

      $.ajax({
        url: GLOBALS.ajaxUrl,
        type: 'post',
        data: {
          action: 'ajax_embed',
          post_id: thePostId
        },
        beforeSend: function() {
          $('#trailerEmbed iframe').remove();
        },
        success: function(result) {
          nodes.embedWrapper.append(result);
        }
      });
    });

    nodes.modal.on('hidden.bs.modal', function () {
      $('#trailerEmbed iframe').remove();
    });
  }

  return {
    init: function () {
      nodes = utils.createNodes(selectors);
      infiniteScroll();
    },
    singleVideoInit: function () {
      nodes = utils.createNodes(selectors);
      playVideoEmbed();
    },
    archiveVideoInit: function () {
      nodes = utils.createNodes(selectors);
      loadVideoEmbed();
    }
  };

})(jQuery);
